import React from 'react'

export const Condition: React.FC = () => {
  return (
    <div className="bp-mt-16">
      <pichincha-typography
        variant="tinyText"
        color="darkGrey"
        weight_color="500"
      >
        *Valores referenciales, no son considerados como una oferta formal de
        préstamo.
        <br />
        <br />
        La oferta definitiva está sujeta al cumplimiento de las condiciones y
        políticas referentes a capacidad de pago.
      </pichincha-typography>
    </div>
  )
}
